<div class="wrapper flex flex-col justify-between">
  <div class="heading flex flex-row items-center justify-between mb-[40px]">
    <div class="text-type-2">
      {{ data?.id || data?.uuid ? data?.name || 'Edit site' : 'Create site' }}
    </div>
  </div>
  <div class="details flex-1">
    <app-text-input
      (checkForErrors)="checkForErrors($event)"
      [error]="errorMessages['name']"
      [parentFormGroup]="form"
      class="w-full mb-[20px]"
      controlName="name"
      label="name"
      />
    <app-date-range-picker
      (checkForErrors)="checkForErrors($event)"
      [error]="errorMessages['start_date'] || errorMessages['end_date']"
      [parentFormGroup]="form"
      endDateControlName="end_date"
      label="Site duration"
      placeholderStart="Start date"
      placeholderEnd="End date"
      startDateControlName="start_date"
      class="w-full mb-[20px]"
      />
    <app-text-input
      (checkForErrors)="checkForErrors($event)"
      [error]="errorMessages['site_value']"
      [parentFormGroup]="form"
      class="w-full mb-[20px]"
      controlName="site_value"
      label="site value"
      />
    <app-text-area
      (checkForErrors)="checkForErrors($event)"
      [error]="errorMessages['description']"
      [parentFormGroup]="form"
      class="w-full mb-[40px]"
      controlName="description"
      label="description"
      />

    <div class="location-section mt-[20px]">
      @if (showLocationSection()) {
        <app-location-section
          (onDelete)="deleteLocation($event)"
          [isEditable]="true"
          [latitude]="form?.controls?.latitude?.value"
          [longitude]="form?.controls?.longitude?.value"
          class="mb-[20px]"
          />
      }
    </div>
  </div>
  <div class="action-section flex gap-[20px] w-full mt-[40px]">
    <app-primary-button (handleClick)="submit()" [isDisabled]="!isFormDirty" class="save-button"
      >Save
    </app-primary-button>
    <div [matMenuTriggerFor]="add" class="action-button add-button">
      <mat-icon class="add" svgIcon="plus" />
    </div>
    <mat-menu #add="matMenu">
      <button (click)="editLocation()" mat-menu-item>
        <div class="add-menu-item">
          <mat-icon svgIcon="marker-outline" class="menu-icon" />
          <div class="menu-label">Location</div>
        </div>
      </button>
    </mat-menu>
  </div>
</div>
